import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Form, Skeleton, Divider, message } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

import {
  getUserFromId,
  putEditProfileUser,
  patchEditePassword,
} from '../../../../services/editarPerfil';
import { getEditarUsuario } from '../../../../services/cadastroUsuario';
import { useAuth } from '../../../../hooks/auth';
import { SelectMultiplo } from '../../../../components/SelectMultiplo';
import { CredencialPerfil } from '../Credencial';
import * as S from './styles.js';

export function PerfilForm() {
  const [form] = Form.useForm();
  const history = useHistory();
  const { atualizarUsuario, carregandoPermissoes } = useAuth();
  const id = localStorage.getItem('@TmovGR:idUsuario')?.toString();
  const longinCurrent = JSON.parse(localStorage.getItem('@TmovGR:usuario'));
  const [usuario, setUsuario] = useState({});
  const [gruposUser, setGruposUser] = useState([]);
  const [loadingUsuario, setLoadingUsuario] = useState(false);
  const [loadingSalvarUsuario, setLoadingSalvarUsuario] = useState(false);
  const [disabletBtn, setDisabletBtn] = useState(true);

  const getGurposDoUsuário = async () => {
    const { data } = await getEditarUsuario({ id });
    return setGruposUser(data?.map(item => item?.nome));
  };

  const salvarUsuario = async formData => {
    setLoadingSalvarUsuario(true);
    const valuesProfileEdit =
      usuario?.nome !== formData?.nome || usuario?.email !== formData?.email;
    const valuesPassword = formData.senha.length > 3;

    /* Se os campos de email e nome forem alterado. * */
    valuesProfileEdit && (await handlerEditarPerfil(formData));

    // /* Se o campo de senha fore alterados. **/
    valuesPassword && (await handlerSalvarNovaSenha(formData));

    setLoadingSalvarUsuario(false);
    setDisabletBtn(false);
  };

  const handlerEditarPerfil = async formData => {
    const { nome, senha } = formData;
    const { cpf, email } = usuario;

    const payload = {
      id: Number(id),
      login: cpf,
      email,
      cpf,
      nome,
      senha,
      ativo: true,
    };

    const { data, error } = await putEditProfileUser({ payload });

    data && message.success('Alterações salvas com sucesso!');

    error &&
      message.error(
        error?.response?.data?.detail || 'Perfil não pode ser salvo'
      );
  };

  const handlerSalvarNovaSenha = async formData => {
    const { senhaAnterior, senha, confirmarSenha } = formData;
    const { login } = longinCurrent;

    const payload = {
      login,
      senhaAtual: senhaAnterior,
      senhaNova: confirmarSenha,
    };

    const validationValues = Object.is(senha, confirmarSenha);

    return (
      validationValues &&
      (async () => {
        const { status, error } = await patchEditePassword({ payload });

        setDisabletBtn(false);
        form.setFields([
          { name: 'senhaAnterior', value: '' },
          { name: 'senha', value: '' },
          { name: 'confirmarSenha', value: '' },
        ]);
        status && message.success('Senha alterada com sucesso.');

        error &&
          message.error(
            error?.response?.data?.detail || 'Senhas não conferem.'
          );
      })()
    );
  };

  const handlerIsEditProfile = async formData => {
    const { nome, senha, confirmarSenha } = formData.currentTarget;
    return nome?.value !== usuario?.nome ||
      (senha?.value?.length > 3 && confirmarSenha?.value?.length > 3)
      ? setDisabletBtn(false)
      : setDisabletBtn(true);
  };

  const buscarUsuario = async () => {
    const { data } = await getUserFromId({ id });

    return { data };
  };

  useEffect(() => {
    atualizarUsuario(usuario || {});
    form.setFields([
      { name: 'nome', value: usuario.nome },
      { name: 'email', value: usuario.email },
      { name: 'senha', value: usuario.password },
      { name: 'cpf', value: usuario.login },
      { name: 'usuario', value: usuario.nome },
      { name: 'perfil', value: usuario.nome },
      { name: 'senhaAnterior', value: '' },
      { name: 'senha', value: '' },
      { name: 'confirmarSenha', value: '' },
      { name: 'grupo', value: gruposUser },
      {
        name: 'cliente',
        value:
          usuario?.clientes?.map(item => item?.cliente?.nomeFantasia) || [],
      },
    ]);
  }, [form, usuario, atualizarUsuario, gruposUser]);

  useEffect(() => {
    async function getUsuario() {
      await getGurposDoUsuário();
      const { data } = await buscarUsuario();
      setUsuario(data || {});
      setLoadingUsuario(false);
    }
    getUsuario();
  }, [carregandoPermissoes]);

  const onFinishFailed = () => {};

  function TitleColluns() {
  return <S.TitleSection>
      <p>Dados cadastrais do usuário</p>
      <Divider
        style={{
          margin: '6px 0 0 0',
          border: '1px solid #BDBDBD',
        }}
      />
         </S.TitleSection>;
}
  return (
    <S.Wrapper>
      <Skeleton loading={loadingUsuario} active />
      {!loadingUsuario && (
        <>
          <S.BlocoStyled id="blocoTitle">
            <Row gutter={[0, 0]} justify="space-between" align="middle">
              <S.TitleBloco level={2}>Meu Perfil</S.TitleBloco>
              <S.ButtonVoltar
                type="primary"
                size="large"
                onClick={() => history.goBack()}
              >
                <LeftOutlined
                  style={{ fontSize: '18px', fontWeight: 'bold' }}
                />
                Voltar
              </S.ButtonVoltar>
            </Row>
          </S.BlocoStyled>
          <S.Columns>
            <S.RowStyled style={{ margin: '24px 24px 0 0' }}>
              <S.ColStyled justify="center">
                <TitleColluns />

                <Form
                  form={form}
                  name="for-edit-profile"
                  onFinish={values => salvarUsuario(values)}
                  onChange={values => handlerIsEditProfile(values)}
                  onFinishFailed={onFinishFailed}
                  layout="vertical"
                  style={{
                    width: '100%',
                    maxWidth: '90%',
                    height: '100%',
                    minWidth: '0',
                  }}
                >
                  <Form.Item
                    name="nome"
                    label="Nome"
                    tooltip="Digite seu nome completo"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '16px',
                      color: '#707070',
                    }}
                  >
                    <S.InputStyled size="large" placeholder={usuario?.nome} />
                  </Form.Item>
                  <CredencialPerfil usuarioId={id} />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '30%',
                    }}
                  >
                    <Form.Item>
                      <S.StyledButton
                        type="primary"
                        loading={loadingSalvarUsuario}
                        htmlType="submit"
                        disabled={disabletBtn}
                      >
                        SALVAR
                      </S.StyledButton>
                    </Form.Item>
                  </div>
                </Form>
              </S.ColStyled>
            </S.RowStyled>
            <S.RowStyled style={{ margin: '24px 0 0 0' }}>
              <S.ColStyled justify="center" span={24}>
                <TitleColluns />
                <Form
                  form={form}
                  name="for-info-profile"
                  layout="vertical"
                  style={{
                    width: '90%',
                    maxWidth: '90%',
                    minWidth: '0',
                  }}
                  onFinish={values => salvarUsuario(values)}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="cpf"
                    label="CPF"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '16px',
                      color: '#707070',
                    }}
                  >
                    <S.InputStyled disabled size="large" />
                  </Form.Item>
                  <Form.Item
                    name="email"
                    label="E-mail"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '16px',
                      color: '#707070',
                    }}
                  >
                    <S.InputStyled disabled size="large" />
                  </Form.Item>
                  <Form.Item
                    name="grupo"
                    label="Grupo"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '16px',
                      color: '#707070',
                    }}
                    disabled
                  >
                    <SelectMultiplo disabled />
                  </Form.Item>
                  <Form.Item
                    name="cliente"
                    label="Cliente"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineHeight: '16px',
                      color: '#707070',
                    }}
                  >
                    <SelectMultiplo disabled />
                  </Form.Item>
                </Form>
              </S.ColStyled>
            </S.RowStyled>
          </S.Columns>
        </>
      )}
    </S.Wrapper>
  );
}
